import { UserManager, WebStorageStateStore } from "oidc-client";
import utils from "../shared/utils";
import logger from "@/utils/logger";

export default class AuthService {
  constructor() { }

  async initialize() {
    var config = await utils.GetConfig();

    const settings = {
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      authority: config.auth_authority,
      client_id: config.auth_client_id,
      client_secret: config.auth_client_secret,
      redirect_uri: config.auth_redirect_base_url + "callback.html",
      silent_redirect_uri: config.auth_redirect_base_url + "silent-renew.html",
      post_logout_redirect_uri: config.auth_redirect_base_url,
      response_type: "code",
      scope: "openid profile AppFramework offline_access",
      filterProtocolClaims: true,
      loadUserInfo: true,
      automaticSilentRenew: true,
      allowAccessTokensViaBrowser: true,
    };

    this.userManager = new UserManager(settings);
    this.userManager.events.addSilentRenewError((e) => {
      logger.log("Failed to renew token error: " + e);
    });
  }

  static async create() {
    const authService = new AuthService();
    await authService.initialize();
    return authService;
  }

  async silentRenew() {
    await this.userManager
      .clearStaleState()
      .then(() => {
        logger.log("clearState success");
      })
      .catch((e) => {
        logger.log("clearStateState error", e.message);
      });

    await this.userManager.signinSilent().then(() => {
      logger.log("signinSilent success");
    })
      .catch((e) => {
        logger.log("signinSilent error", e.message);
      });
  }
  getUser() {
    return this.userManager.getUser();
  }
  login() {
    return this.userManager.signinRedirect();
  }
  logout() {
    return this.userManager.signoutRedirect();
  }
  async getAccessToken() {
    var user = await this.getUser();
    return user.access_token;
  }
}
